"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _useKeyEvent = _interopRequireDefault(require("../hooks/useKeyEvent"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
/**
 * Trigger callback on window's keydown event for the specified key (name)
 * Pass true as the 3rd argument in order to preventDefault of the event
 */


var useKeydown = function useKeydown(key, onKeydown, preventDefault) {
  return (0, _useKeyEvent["default"])(key, onKeydown, 'keydown', preventDefault);
};

__signature__(useKeydown, "useKeyEvent{}", function () {
  return [_useKeyEvent["default"]];
});

var _default = useKeydown;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useKeydown, "useKeydown", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useKeydown.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useKeydown.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();